/* eslint-disable jsx-a11y/alt-text */
import React, {Component} from "react"
import {ListGroup, Card,} from "react-bootstrap"
import {
    getVideoByCategory,
    // getAllQuestion,
    addCommentsVideos,
    getUserByToken,
    getAllVideos,
} from "../../services/Api"
import "../BodyContent.scss"
import {handleUserSetup} from "../../redux/actions/User"
import {MongoTimeConvert} from "../../converters/timeConverters"
import {connect} from "react-redux"

import {toast} from "react-toastify"
import VideoSideBar from "./VideoSideBar"
// import VideosFeed from "../feed/videos"
import VideoComments from "../../comments/VideoComments"
import QuestionsFeed from '../feed/questions';
import {v4 as uuidv4} from 'uuid';
import MainLoader from "../loader/MainLoader"


const EDUCATE_TOKEN = "educate_token"

class Videos extends Component {
    constructor() {
        super()

        this.state = {
            diplay: "none",
            data: [],
            allVideos: [],
            loading: true
        }

        this._onKeyUp = (e) => {
            const data = this.state.allVideos.filter((item) =>
                item.videoDescription
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            )
            this.setState({
                ...this.state,
                data
            })
        }

        this.loadNewQuestions = async (params) => {
            const categoryid = {
                id: params,
            }
            const data = await getVideoByCategory(categoryid)
            this.setState({
                ...this.state,
                data: data,
                allVideos: data
            })
        }

        this.addComments = async (id, comment, userName) => {
            var user = ""
            console.log(this.props.currentUser.fullName)
            if (this.props.currentUser.fullName === undefined && userName) {
                user = userName
            } else if (
                this.props.currentUser.fullName === undefined &&
                !userName
            ) {
                user = "Anonymous"
            } else {
                user = this.props.currentUser.fullName
            }

            console.log(user)
            const commentData = {
                videoId: id,
                user: user,
                comment: comment,
            }

            const commentdata = await addCommentsVideos(commentData)
            toast(commentdata.message, {type: "success"})
            this.componentDidMount()
        }
    }

    displayComments(displayComments, id) {
        var newDisplay = ""
        const allVideos = this.state.data
        for (var i = 0; i < allVideos.length; i++) {
            if (allVideos[i]._id === id) {
                if (allVideos[i].displayComments === "block") {
                    newDisplay = "none"
                } else {
                    newDisplay = "block"
                }
                allVideos[i].displayComments = newDisplay
            }
        }
        this.setState({
            ...this.state,
            data: allVideos
        })
    }

    async checkLogedIn() {
        if (localStorage.getItem(EDUCATE_TOKEN)) {
            const user = await getUserByToken()
            this.props.dispatch(handleUserSetup(user.user))
            this.setState({
                ...this.state,
                user: true,
                displayButtons: "block",
            })
        } else {
            console.log("User not logged in")
        }
    }

    async componentDidMount() {
        this.checkLogedIn()
        const videos = await getAllVideos()
        this.setState({
            ...this.state,
            data: videos,
            allVideos: videos,
            loading: false
        })
    }

    render() {
        return (
            <React.Fragment>
                <MainLoader loading={this.state.loading} />
                <div className='contentDiv'>
                    <div className='col-lg-2' id="sidebarContent">
                        <VideoSideBar LoadQuestion={this.loadNewQuestions}/>
                    </div>
                    <div className='col-lg-6'>
                        <div className='middleSection'>
                            <div className='generalQuestion'>
                               View videos below
                            </div>
                        </div>
                        {this.state.data != null && this.state.data.map((item) => (
                            <div key={uuidv4()} className='questionsCard'>
                                <Card>
                                    <Card.Body>
                                        <Card.Header>
                                            <div className='headerStructure'>
                                                <div className='userNameAndIcon'>
                                                    <div className='imageIcon'>
                                                        <img
                                                            src={require("../../icons/iconuser.png")}
                                                         alt="User Icon"/>
                                                    </div>
                                                    <div className='ownerName'>
                                                        {item.user.fullName}
                                                        <span>
															{" "}
                                                            {MongoTimeConvert(
                                                                item
                                                                    .createdAt
                                                            )}
														</span>{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Header>
                                        <Card.Text>
                                            {item.videoDescription}
                                        </Card.Text>
                                    </Card.Body>
                                    <video
                                        controls
                                        className='userVideos'
                                        src={item.videoLink}
                                    />

                                    <div>
                                        <div className='commentIcon'>
                                            <div
                                                onClick={() =>
                                                    this.displayComments(
                                                        item.displayComments,
                                                        item._id
                                                    )
                                                }
                                                className='imageIcon'
                                            >
                                                <img
                                                    className='cardIcon'
                                                    src={require("../../icons/comment-outlined.svg")}
                                                />
                                                <span>
													{item.comments.length}
												</span>
                                            </div>

                                        </div>
                                    </div>
                                    <div>
                                        <div
                                            style={{
                                                display: item.displayComments,
                                            }}
                                        >
                                            <VideoComments
                                                userComment={item.comments}
                                                video={item._id}
                                                addComments={this.addComments}
                                            />
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        ))}
                    </div>
                    <div className='col-lg-2' id='improve-your-feed'>
                        <div className='middleSection'>
                            <ListGroup>
                                <ListGroup.Item className='listFirstItem feedCateGoryName'>
                                    Improve Your feed{" "}
                                </ListGroup.Item>
                                <QuestionsFeed/>
                            </ListGroup>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps({currentUser}) {
    return {
        currentUser: currentUser,
    }
}

export default connect(mapStateToProps)(Videos)
